'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = youTubeTracking;

var _rpAnalytics = require('rp-analytics');

var segmentio = _interopRequireWildcard(_rpAnalytics);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function youTubeTracking() {
    var youTubePlayersOnPage = document.querySelectorAll('iframe[src*="youtu"]');

    /*
     * Load Youtube Iframe API script
     * Remove unused stuff from video attr and add origin host
     * https://racingpost.atlassian.net/browse/NEWS-2404
     */
    if (youTubePlayersOnPage.length !== 0) {
        loadYoutubeIframeScript("https://www.youtube.com/iframe_api");
        for (var i = 0; i < youTubePlayersOnPage.length; i++) {
            var url = youTubePlayersOnPage[i].getAttribute('src');
            var connectionSymbol = url.indexOf('?') === -1 ? '?' : '&';
            url = url.replace('?rel=0', '') + connectionSymbol + 'origin=' + window.location.protocol + '//' + window.location.hostname;
            youTubePlayersOnPage[i].setAttribute('src', url);
        }
    }

    /*
     * This script needed for logging user actions on Youtube players
     * https://racingpost.atlassian.net/browse/NEWS-2404
     */
    function loadYoutubeIframeScript(src) {
        var s = void 0;
        s = document.createElement('script');
        s.type = 'text/javascript';
        s.src = src;
        document.body.appendChild(s);
    }

    /*
     * Getting all Youtube players on page and adding event handlers
     * https://racingpost.atlassian.net/browse/NEWS-2404
     */
    var player = void 0;
    window.onYouTubeIframeAPIReady = function () {
        var playersOnPage = document.querySelectorAll('.embed-responsive-item');
        var countPlayersOnPage = playersOnPage.length;

        for (var _i = 0; _i < countPlayersOnPage; _i++) {
            var playerId = playersOnPage[_i].id;

            player = new YT.Player(playerId, {
                events: {
                    'onStateChange': onPlayerStateChange
                }
            });
        }
    };

    /*
     * Tracking all events happened with Youtube players
     * https://racingpost.atlassian.net/browse/NEWS-2404
     */
    function onPlayerStateChange(event) {
        // get player data from event to avoid loop event closure issue
        var player = event.target;
        switch (event.data) {
            case YT.PlayerState.PLAYING:
                segmentio.track('Video Played', {
                    video: player.getVideoData().title,
                    id: player.getVideoData().video_id,
                    duration: player.getDuration()
                });
                break;
            case YT.PlayerState.PAUSED:
                segmentio.track('Video Paused', {
                    video: player.getVideoData().title,
                    id: player.getVideoData().video_id,
                    pausedAt: player.getCurrentTime()
                });
                break;
            case YT.PlayerState.ENDED:
                segmentio.track('Video Finished', {
                    video: player.getVideoData().title,
                    id: player.getVideoData().video_id,
                    duration: player.getDuration()
                });
                break;
            default:
                return;
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./public/js/youTubeTracking.js
// module id = 651
// module chunks = 0